import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

/**
 * Checks if the current browser is Internet Explorer 11.
 * @returns {boolean} - Returns true if the current browser is Internet Explorer 11.
 */
export default () =>
  !!ssrWindow.MSInputMethodContext && !!ssrWindow.document.documentMode
